import React from 'react';
import { KpiCard as KpiCardType, KpiIcon } from '../driverPerformanceTypes';
import styles from './KpiCard.module.css';

interface KpiCardProps {
  kpi: KpiCardType;
}

const icons: Record<KpiIcon, React.ReactNode> = {
  check: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
    </svg>
  ),
  clipboard: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
      <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z" />
    </svg>
  ),
  alert: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
      <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
    </svg>
  ),
  wallet: (
    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
      <path d="M21 7.28V5c0-1.1-.9-2-2-2H5C3.89 3 3 3.9 3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-2.28A2 2 0 0 0 22 15V9a2 2 0 0 0-1-1.72zM20 9v6h-7V9h7zM5 19V5h14v2h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6v2H5z" />
      <circle cx="16" cy="12" r="1.5" />
    </svg>
  ),
};

export const KpiCard: React.FC<KpiCardProps> = ({ kpi }) => {
  return (
    <div className={styles.card}>
      <div className={`${styles.iconBox} ${styles[`icon_${kpi.color}`]}`}>
        {icons[kpi.icon]}
      </div>
      <p className={styles.label}>{kpi.label}</p>
      <p className={`${styles.value} ${styles[`value_${kpi.color}`]}`}>{kpi.value}</p>
    </div>
  );
};
